import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import ScrollFeatures from "../sections/ScrollFeatures";
import WhySiara from "../sections/WhySiara";
import OrderSection from "../sections/OrderSection";

const Home = () => {
  return (
    <Container>
      <Navbar />
      <Hero />
      <ScrollFeatures />
      <WhySiara />
      <OrderSection />
      <Footer />
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  scroll-behavior: smooth;
`;

export default Home;
